let ownedRoutes: RegExp[] = []

/**
 * Set at boot from `app.routes.spa` — the backend translates its own url rules, so this stack never
 * keeps a second copy of the route split.
 */
export const configureOwnedRoutes = (patterns: string[]) => {
    ownedRoutes = patterns.map(pattern => new RegExp(pattern))
}

export const isHardNavigationRoute = (url: string): boolean => {
    if (ownedRoutes.length === 0) {
        return false
    }

    const { origin, pathname } = new URL(url, document.location.origin)

    if (origin !== document.location.origin) {
        return false
    }

    return !ownedRoutes.some(route => route.test(pathname))
}
